import React, {Fragment, useEffect} from 'react';

import {useCarrouselIndexStore} from 'presentation/components/Carrousel/store';
import {useLocation} from 'react-router-dom';
import {useMediaQueries} from '../hooks';
import {ErrorEvaluating, RefuseEvaluation, SelectEvaluations} from './components';
import {MobileSelectEvaluations} from './components/Modals/MobileSelectEvaluations';
import {useGetFiveStarsQuery} from './queries/useGetFiveStarsQuery';
import {FiveStarsProps} from './types';
import {useRatingFormDataStore} from './stores/useRatingFormDataStore';
import {useRatingModalStore} from './stores/useRatingModalStore';
import {useMobileRefuseModalStore} from './stores/useMobileRefuseModalStore';

export function FiveStars({hideComponent}: FiveStarsProps) {
	const {isMobile} = useMediaQueries();
	const {pathname} = useLocation();
	const {data: ratings} = useGetFiveStarsQuery();
	const carrouselIndex = useCarrouselIndexStore(state => state.carrouselIndex);
	const resetRatingDataForm = useRatingFormDataStore(state => state.resetRatingFormData);
	const ratingModal = useRatingModalStore(state => state.ratingModal);
	const setRatingModal = useRatingModalStore(state => state.setRatingModal);
	const mobileRefuseModal = useMobileRefuseModalStore(state => state.refuseModal);
	const setMobileRefuseModal = useMobileRefuseModalStore(state => state.setRefuseModal);

	useEffect(() => {
		resetRatingDataForm();
	}, []);

	useEffect(() => {
		setRatingModal('evaluate');
	}, [pathname]);

	useEffect(() => {
		if (ratingModal === 'refuse') {
			if (isMobile) {
				setRatingModal('evaluate');
			}
		}
		if (mobileRefuseModal) {
			if (!isMobile) {
				setMobileRefuseModal(false);
			}
		}
	}, [ratingModal, isMobile, mobileRefuseModal]);

	if (!ratings) {
		return null;
	}

	const ratingDetail = ratings.items[carrouselIndex];

	if (hideComponent) return null;

	return (
		<Fragment>
			{isMobile ? (
				<Fragment>
					{ratingModal === 'evaluate' && (
						<MobileSelectEvaluations ratings={ratings} ratingDetail={ratingDetail} />
					)}
				</Fragment>
			) : (
				<Fragment>
					{ratingModal === 'evaluate' && <SelectEvaluations ratings={ratings} />}
					{ratingModal === 'refuse' && <RefuseEvaluation ratingDetail={ratingDetail} />}
				</Fragment>
			)}
			{ratingModal === 'error' && <ErrorEvaluating ratingDetail={ratingDetail} />}
		</Fragment>
	);
}
